<template>
  <div class="explore">
    <div
      class="google-map"
      ref="googleMap"
      style="width: 100%; height: 100vh"
    ></div>

    <v-btn
      v-if="garden.position"
      style="position: fixed; top: 0; right: 0; z-index: 2"
      x-large
      depressed
      rounded
      outlined
      class="ma-3 glassmorphism text-none primary--text"
      @click="getUserPosition()"
      icon
      ><v-icon color="primary" size="24">mdi-crosshairs-gps</v-icon></v-btn
    >

    <v-row
      v-if="!garden.position"
      no-gutters
      justify="center"
      style="position: fixed; bottom: 70px; right: 0; left: 0; z-index: 2"
      ><v-btn
        x-large
        depressed
        rounded
        outlined
        class="my-4 glassmorphism text-none primary--text"
        @click="getUserPosition()"
        ><v-icon color="primary" size="24" left class="mr-3"
          >mdi-crosshairs-gps</v-icon
        >Locate my garden</v-btn
      ></v-row
    >

    <v-dialog
      v-model="dialogGarden"
      class="rounded-xl"
      content-class="dialog-garden "
      overlay-opacity="0.2"
      max-width="calc(100vw - 30px)"
      transition="dialog-bottom-transition"
      origin="center bottom"
    >
      <v-card min-height="300">
        <Plants :visitor="true" :gardenId="selectedGardenId"
      /></v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Loader } from "@googlemaps/js-api-loader";
import Plants from "@/components/garden/Plants.vue";

export default {
  components: {
    Plants,
  },
  computed: {
    ...mapState("gardens", [
      "garden",
      "gardenPending",
      "gardens",
      "gardensPending",
    ]),
    ...mapState("self", ["self", "selfPending"]),
  },
  watch: {
    gardens(val) {
      val.forEach((element) => {
        this.setMarker(element);
      });
    },
    "$route.params.gardenId": {
      handler: function (val) {
        if (val && val !== "all") {
          this.exploreGarden({ gardenId: val });
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      dialogGarden: false,
      google: null,
      map: null,
      apiKey: "AIzaSyAUzrbhE5OHrZSrG03jViLZd_rcIGRpLrY", // add your google API key here
      gardenPosition: null,
      selectedGardenId: null,
    };
  },
  mounted() {
    this.loadMap();
  },
  methods: {
    setMarker(data) {
      const marker = new google.maps.Marker({
        ...data,
        position: new google.maps.LatLng(
          data.position.latitude,
          data.position.longitude
        ),
        map: this.map,
        icon: this.getImage(data),
        animation: google.maps.Animation.DROP,
      });

      marker.addListener("click", (listener) => {
        this.exploreGarden({ gardenId: data.id, position: marker.position });
      });
    },
    async exploreGarden(payload) {
      this.selectedGardenId = payload.gardenId;
      let _self = this;
      setTimeout(function () {
        _self.dialogGarden = true;
      }, 300);
      this.$router.push(`/explore/${payload.gardenId}`).catch(() => {});
      this.$store.dispatch(`users/getUser`, payload.gardenId);
      this.$store.dispatch(`plants/getPlants`, payload.gardenId);
      if (payload.position) {
        this.map.panTo(payload.position);
      } else {
        await this.$store.dispatch(`gardens/getGarden`, payload.gardenId);
        let position = new google.maps.LatLng(
          this.garden.position.latitude,
          this.garden.position.longitude
        );
        this.map.panTo(position);
      }
    },
    getImage(garden) {
      if (garden.numberOfFlowers >= 7) return "/img/illustrations/4.svg";
      if (garden.numberOfFlowers >= 5) return "/img/illustrations/3.svg";
      if (garden.numberOfFlowers >= 3) return "/img/illustrations/2.svg";
      return "/img/illustrations/1.svg";
    },
    async getUserPosition() {
      if (navigator.geolocation) {
        this.$store.commit(`snackbar/setSnackbar`, {
          color: "info",
          timeout: 16000,
          text: "Detecting your position",
          loading: true,
        });
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            window.localStorage.setItem("latitude", position.coords.latitude);
            window.localStorage.setItem("longitude", position.coords.longitude);
            const pos = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.map.setZoom(18);
            this.map.panTo(pos);
            if (this.gardenPosition) {
              this.gardenPosition.setMap(null);
            }
            this.$store.dispatch("level/updateLevel", {
              field: "position",
              value: true,
            });
            await this.$store.dispatch("gardens/updateGarden", {
              position: pos,
            });
            this.exploreGarden({ gardenId: this.self.id });
            let garden = await this.$store.dispatch(
              "gardens/getGarden",
              this.self.id
            );
            this.setMarker(garden);

            this.$store.commit(`snackbar/setSnackbar`, {
              active: false,
              color: "info",
            });
          },
          () => {
            this.$store.commit("snackbar/setSnackbar", {
              color: "error",
              timeout: 3000,
              text: "Geolocation Failed",
            });
          }
        );
      } else {
        // Browser doesn't support Geolocation
        this.$store.commit("snackbar/setSnackbar", {
          color: "error",
          timeout: 3000,
          text: "Geolocation Not Supported",
        });
      }
    },

    loadMap() {
      const loader = new Loader({
        apiKey: this.apiKey,
        version: "weekly",
      });
      loader
        .load()
        .then(() => {
          this.map = new google.maps.Map(this.$refs.googleMap, {
            center: {
              lat:
                parseFloat(window.localStorage.getItem("latitude")) ||
                10.778378232056642,
              lng:
                parseFloat(window.localStorage.getItem("longitude")) ||
                106.6736442387736,
            },
            zoom: 13,
            minZoom: 3,
            maxZoom: 20,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: false,
            styles: [
              {
                featureType: "poi",
                stylers: [{ visibility: "off" }],
              },
              {
                featureType: "transit",
                stylers: [{ visibility: "off" }],
              },
            ],
          });

          this.$store.dispatch(`gardens/getGardens`);
        })
        .catch((e) => {});
    },
  },
};
</script>
<style >
.dialog-garden {
  position: fixed;
  bottom: 15px;
  margin: 0px;
  border-radius: 20px !important;
}
</style>